import GoalList from './GoalList';

export default GoalList;
